import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import Tooltip from 'scoreboard/components/tooltip'
import _ from 'lodash'

function isSpecificColor(model, serie) {
	const plotType = serie.get('plotType')
	const colorSetting = (model.get('colors') || [])
		.find(c => c.plotType === plotType) || {}
	return colorSetting.colorType === 'specific'
}

function isScoreType(model, serie) {
	const domainType = serie.domainType()
	const plotType = serie.get('plotType')
	const colorSetting = (model.get('colors') || [])
		.find(c => c.plotType === plotType) || {}
	return ['scorecard-item', 'initiative'].includes(domainType) &&
		colorSetting.colorType === 'score'
}

/**
 * Determines if the color selector should show in the edit menu. It should
 * show if none of the following are true:
 * 1. The color type for this plot type is set to "specific"
 * 2. The color type for this plot type is set to "score" AND the source of
 *    the serie is a scorecard or an initiative
 *
 * @param {ChartDesigner} model
 * @param {ChartDesignerSerie} serie
 */
function isColorOptionDisabled(model, serie) {
	if (isSpecificColor(model, serie)) return true
	if (isScoreType(model, serie)) {
		if (![ 'line', 'area' ].includes(serie.get('plotType'))) return true

		// #39892 should be enabled if there are multiple features
		const series = _.filter(model.get('features'), f => f.type === 'serie')
		return series.length <= 1
	}
	return false
}

/**
 * #37638 Replaces the color menu option when editing a chart serie if the color
 * cannot be manually set. Clicking this option will display a tooltip explaining
 * the situation
 */
const ColorDisabledMenuOption = Backbone.View.extend({
	className: 'color-disabled-menu-option is-disabled',

	events: {
		'click': 'showTooltip'
	},

	initialize: function(options) {
		this.options = options
	},

	render: function() {
		this.$el.empty().text(i18n.get('charts.chart.color'))
		return this
	},

	/**
	 * Displays a tooltip when this option is clicked explaining where the colors
	 * are coming from
	 */
	showTooltip: function() {
		let content = ''
		if (isSpecificColor(this.options.model, this.options.serie)) {
			const plotType = i18n.get(`charts.chart.plotType.${this.options.serie.get('plotType')}`)
			content = i18n.get('charts.chart.colorBySpecificTooltip', plotType)
		} else {
			const domainType = this.options.serie.domainType()
			const scoreType = domainType === 'scorecard-item' ?
				'scorecards.scorecard' : 'initiatives.initiative'
			let messageCode = 'charts.chart.colorByScoreTooltip'
			if (this.options.serie.get('plotType') === 'line') {
				messageCode += '.line'
			}
			content = i18n.get(messageCode, scoreType)
		}
		this.tooltip = new Tooltip({
			// attach to the parent so the tooltip shows completely outside of the menu
			attachTo: this.$el.parent(),
			content,
			closeOnChangedFocus: true,
			closeOnAttachedToClick: true,
			placement: 'right',
			arrow: 'bottom'
		}).render()
		this.on('slide:away', () => _.invoke(this.tooltip, 'remove'))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.tooltip], 'remove')
	}
})

export { ColorDisabledMenuOption }
export { isColorOptionDisabled }
